if (!customElements.get("accompanying-products")) {
	customElements.define(
		"accompanying-products",
		class AccompanyingProducts extends HTMLElement {
			constructor() {
				super()

				this.addEventListener("change", this.handleAprodChange.bind(this))
			}

			handleAprodChange(e) {
				//ensure type of target is select
				if (e.target.tagName.toLowerCase() !== "select") return

				//get current variant
				const variant_id = parseInt(e.target.value)
				const product_title = e.target.options[e.target.selectedIndex].dataset.product

				if (!variant_id) return

				var uniqueHash = this.dataset.hash + Date.now() //unique hash for this product, time added to separate products

				//iterate over product forms, adding items[x] to inputs

				const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)

				productForms.forEach((productForm) => {
					const input = productForm.querySelector('input[name="id"]')

					if (input) {
						//set single input to array-obj style
						input.name = "items[0][id]"

						//check for properties
						var property_inputs = productForm.querySelectorAll('input[name*="properties"]')

						Array.from(property_inputs).forEach((input) => {
							var current_name = input.name
							var new_name = `items[0][properties]${current_name.replace("properties", "")}` //brackets included
							input.name = new_name
						})

						input.dispatchEvent(new Event("change", { bubbles: true }))
					}

					//check for type set
					const type = this.dataset.type
					const type_input = productForm.querySelector(`input[name="items[0][properties][${type}]"]`)
					if (!type_input) {
						//attach type property to base product
						const type_input = this.createInput("0", "properties", product_title, type)
						productForm.append(type_input)
					} else {
						type_input.value = product_title
					}

					//set the base product's hash each time
					const hash_input = productForm.querySelector('input[name="items[0][properties][_aprod_base]"]')
					if (!hash_input) {
						const new_hash_input = this.createInput("0", "properties", uniqueHash, "_aprod_base")
						productForm.append(new_hash_input)
					} else {
						hash_input.value = uniqueHash
					}

					//matching aprod
					const matching_aprod = productForm.querySelector(`input[name="items[2][properties][_aprod_product]"]`)
					if (!matching_aprod) {
						var matching_aprod_input = this.createInput(2, "properties", uniqueHash, "_aprod_product")

						productForm.prepend(matching_aprod_input)
					} else {
						matching_aprod.value = uniqueHash
					}

					// items[2] reserved for accompanying product (1 is for upsell)
					const aprod_id_input = productForm.querySelector('input[name="items[2][id]"]')

					if (aprod_id_input) {
						// already has upsell, change variant ID
						aprod_id_input.value = e.target.value
					} else {
						let new_input = this.createInput(2, "id", variant_id)

						productForm.prepend(new_input)
					}
				})
			}

			createInput(index, key, value, inner_key = false) {
				//returns a hidden input element with name items[index][key][inner_key] (if inner_key is passed)
				let new_input = document.createElement("input")
				new_input.type = "hidden"
				new_input.name = inner_key ? `items[${index}][${key}][${inner_key}]` : `items[${index}][${key}]`
				new_input.value = value

				return new_input
			}
		}
	)
}
